import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { api } from "../../lib/api";

export default function ChatBell() {
  const [count, setCount] = useState(0);

  const tick = useCallback(() => {
    api.post("/chat/presence/ping").catch(() => {});
    api.get("/chat/unread-count").then((r) => setCount(r.data.count || 0)).catch(() => {});
  }, []);

  useEffect(() => {
    tick();
    const iv = setInterval(tick, 20000);
    return () => clearInterval(iv);
  }, [tick]);

  return (
    <Link to="/os/chat" data-testid="chat-bell" title="Mensajes"
      className="relative w-10 h-10 rounded-full flex items-center justify-center text-navy/60 hover:text-navy hover:bg-navy/5 transition-colors">
      <MessageCircle className="w-5 h-5" />
      {count > 0 && (
        <span data-testid="chat-unread-badge"
          className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-gradient-violet text-white text-[10px] font-medium flex items-center justify-center">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </Link>
  );
}
